// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"607":"f28087a3109e545199b6","610":"d49bdece1e2623db4be3"}[chunkId] + ".bundle.js";
};